(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("LegoLayout", ["React"], factory);
	else if(typeof exports === 'object')
		exports["LegoLayout"] = factory(require("React"));
	else
		root["LegoLayout"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition